import { Power1, gsap } from 'gsap';

import { gsapTimelineFunc } from '../gsap-config';

export const fadeIn: gsapTimelineFunc = (targets) => {
  return gsap.timeline().fromTo(
    targets,
    {
      duration: 0,
      opacity: 0,
      ease: Power1.easeOut,
    },
    {
      duration: 1,
      opacity: 1,
      ease: Power1.easeOut,
    }
  );
};
